import first from 'lodash/first'
import React, { FC } from 'react'

import { Link } from '@Components/Link'
import { MediaGalleryCard, MediaGalleryCardProps } from '@Components/MediaGalleryCard'
import { PageType } from '@Generated/graphql'

interface MediaGalleryDefaultCardProps {
  card: MediaGalleryCardProps
  openModal: (pageType?: PageType, id?: string) => void
}

export const MediaGalleryDefaultCard: FC<MediaGalleryDefaultCardProps> = ({ card, openModal }) => {
  const ref = first(card.link?.references || []) as { id?: string, type?: string }
  const useModal = ref?.type === 'modals'
  if (!useModal && card.link?.url) {
    return (
      <Link
        href={card.link?.url}
        target={card.link?.newTab ? '_blank' : undefined}
      >
        <MediaGalleryCard {...card} />
      </Link>
    )
  }
  if (ref?.type === 'modals') {
    return <MediaGalleryCard {...card} onClick={() => openModal(PageType.Modal, ref?.id)} />
  }
  return <MediaGalleryCard {...card} />
}
